import React, { useEffect, useState } from 'react';
import logoImage from '../img/napvirag_logo1.png';
import { getDocumentUrl } from '../utils/documentUrl';
import { filterDocumentsForPublicMenu } from '../utils/documentDev';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const FALLBACK_FOOTER_LINKS = [
  { name: 'Szervezeti és Működési Szabályzat', href: '/pdf/SzMSz.pdf' },
  { name: 'Adatvédelmi Szabályzat', href: '/pdf/napvirag_adatvedelmi_es_adatkezelesi_szabalyzat.pdf' }
];

const Footer = () => {
  const [footerDocs, setFooterDocs] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/documents?placement=footer`)
      .then((res) => (res.ok ? res.json() : []))
      .then((list) => {
        const docs = Array.isArray(list) ? list : [];
        setFooterDocs(filterDocumentsForPublicMenu(docs, { allowExternalUrl: true }));
      })
      .catch(() => setFooterDocs([]))
      .finally(() => setLoaded(true));
  }, []);

  const links = loaded && footerDocs.length > 0
    ? footerDocs.map((doc) => ({ name: doc.name, href: getDocumentUrl(doc) }))
    : FALLBACK_FOOTER_LINKS;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="logo">
              <img src={logoImage} alt="Napvirág Idősek Otthona" className="footer-logo-image" />
            </div>
            <p>Átlagot meghaladó minőségű gondoskodás Budakalászon. Modern, négyszintes épületben 123 akadálymentes apartman és teljes körű szolgáltatások 2006 óta.</p>
          </div>
          <div className="footer-contact">
            <h4>Kapcsolati Információk</h4>
            <p>+36 26 541 000</p>
            <p>napviragotthon@napviragotthon.hu</p>
            <p>Budakalász, Klisovác u. 19, 2011 Magyarország</p>
          </div>
          <div className="footer-legal">
            <h4>Jogi Információk</h4>
            {links.map((link) => (
              <p key={`${link.href}-${link.name}`}>
                <a href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.name}
                </a>
              </p>
            ))}
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Napvirág Idősek Otthona. Minden jog fenntartva.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
